/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Error_FieldsInputs */

const en_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in all fields.`)
};

const de_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte füll alle Felder aus.`)
};

const fr_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplis tous les champs.`)
};

const es_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, complete todos los campos.`)
};

const it_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compila tutti i campi.`)
};

const nl_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul alle velden in.`)
};

const pl_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypełnij wszystkie pola.`)
};

const fi_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täytä kaikki kentät.`)
};

const da_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udfyld venligst alle felter.`)
};

const sv_salary_negotiate_error_fields = /** @type {(inputs: Salary_Negotiate_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyll i alla fält.`)
};

/**
* | output |
* | --- |
* | "Please fill in all fields." |
*
* @param {Salary_Negotiate_Error_FieldsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_error_fields = /** @type {((inputs?: Salary_Negotiate_Error_FieldsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Error_FieldsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_error_fields(inputs)
	if (locale === "fr") return fr_salary_negotiate_error_fields(inputs)
	if (locale === "es") return es_salary_negotiate_error_fields(inputs)
	if (locale === "it") return it_salary_negotiate_error_fields(inputs)
	if (locale === "nl") return nl_salary_negotiate_error_fields(inputs)
	if (locale === "pl") return pl_salary_negotiate_error_fields(inputs)
	if (locale === "fi") return fi_salary_negotiate_error_fields(inputs)
	if (locale === "da") return da_salary_negotiate_error_fields(inputs)
	if (locale === "sv") return sv_salary_negotiate_error_fields(inputs)
	return en_salary_negotiate_error_fields(inputs)
});